import React from "react";
import { ChevronRight, Flag, Zap, Download } from "lucide-react";
import { RunMap } from "../../components/RunMap";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { format } from "date-fns";
import { activityTypeLabels, formatRunTime } from "../../constants/running";

// Post-run summary: splits, stats and the on-demand AI analysis.
const RunSessionSummary = ({
  aiAnalysis,
  aiAnalysisLoading,
  fetchRunningData,
  requestAiAnalysis,
  sessionGpsTrack,
  setRunningView,
  viewingSessionSummary,
  downloadGpx,
}) => {
  return (
    <div className="session-summary-view">
      <Button variant="ghost" size="sm" onClick={() => { setRunningView("list"); fetchRunningData(); }}><ChevronRight size={16} className="rotate-180" /> Powrót</Button>
      <h2><Flag size={24} /> Podsumowanie {activityTypeLabels[viewingSessionSummary.activity_type]?.toLowerCase() || "treningu"}</h2>
      <p className="summary-date">{format(new Date(viewingSessionSummary.started_at), "d MMMM yyyy, HH:mm")}</p>
      {viewingSessionSummary.plan_snapshot?.name && <p className="summary-plan-name">Plan: {viewingSessionSummary.plan_snapshot.name}</p>}

      <div className="summary-stats-grid fade-in-stagger">
        <Card className="summary-stat"><CardContent><span className="summary-val">{viewingSessionSummary.total_distance_km?.toFixed(2)}</span><span className="summary-lbl">km</span></CardContent></Card>
        <Card className="summary-stat"><CardContent><span className="summary-val">{formatRunTime(viewingSessionSummary.total_duration_seconds || 0)}</span><span className="summary-lbl">czas</span></CardContent></Card>
        <Card className="summary-stat"><CardContent><span className="summary-val">{viewingSessionSummary.average_pace?.toFixed(1)}</span><span className="summary-lbl">min/km</span></CardContent></Card>
        <Card className="summary-stat"><CardContent><span className="summary-val">{viewingSessionSummary.calories_burned || "-"}</span><span className="summary-lbl">kcal</span></CardContent></Card>
      </div>

      {sessionGpsTrack.length >= 2 && (
        <div style={{ margin: "16px 0" }}>
          <RunMap gpsPoints={sessionGpsTrack} isLive={false} height={220} />
          <Button variant="outline" size="sm" onClick={downloadGpx} style={{ marginTop: 8 }}>
            <Download size={16} /> Pobierz GPX
          </Button>
        </div>
      )}

      {viewingSessionSummary.ai_messages?.length > 0 && (
        <Card className="coach-log-card">
          <CardHeader><CardTitle>Komunikaty trenera AI</CardTitle></CardHeader>
          <CardContent>
            <ScrollArea className="coach-log-scroll">
              {viewingSessionSummary.ai_messages.map((msg, idx) => (
                <div key={idx} className={`coach-log-item coach-${msg.message_type}`}>
                  <span className="coach-log-time">{msg.timestamp ? format(new Date(msg.timestamp), "HH:mm:ss") : ""}</span>
                  <span className="coach-log-msg">{msg.message}</span>
                </div>
              ))}
            </ScrollArea>
          </CardContent>
        </Card>
      )}

      <Card className="ai-analysis-card">
        <CardHeader><CardTitle><Zap size={18} /> Analiza AI</CardTitle></CardHeader>
        <CardContent>
          {aiAnalysis ? (
            <div className="ai-analysis-text" style={{ whiteSpace: "pre-wrap" }}>{aiAnalysis}</div>
          ) : (
            <Button onClick={() => requestAiAnalysis(viewingSessionSummary.id)} disabled={aiAnalysisLoading}>
              {aiAnalysisLoading ? "Analizuję..." : "Poproś o analizę AI"}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default RunSessionSummary;
